const ACCOUNT_MENU_SELECTOR = '.my-account-menu';
const ACCOUNT_BUBBLE_SELECTOR = '.my-account-menu-bubble';
const DESKTOP_BREAKPOINT_ACCOUNT_MENU = 801;

function isDesktop(): boolean {
    return window.innerWidth > DESKTOP_BREAKPOINT_ACCOUNT_MENU;
}

function closeAccountMenu(): void {
    document.querySelectorAll<HTMLElement>(ACCOUNT_MENU_SELECTOR).forEach(el => el.classList.remove('active'));
    document.querySelectorAll<HTMLElement>(ACCOUNT_BUBBLE_SELECTOR).forEach(el => el.classList.remove('active'));
}

function toggleAccountMenu(): void {
    const trigger = document.querySelector<HTMLElement>(ACCOUNT_MENU_SELECTOR);
    if (!trigger) return;

    const isActive = trigger.classList.contains('active');
    if (isActive) {
        closeAccountMenu();
    } else {
        document.querySelectorAll<HTMLElement>(ACCOUNT_MENU_SELECTOR).forEach(el => el.classList.add('active'));
        document.querySelectorAll<HTMLElement>(ACCOUNT_BUBBLE_SELECTOR).forEach(el => el.classList.add('active'));
    }
}

document.addEventListener('click', (event: MouseEvent) => {
    if (!isDesktop()) return;

    const target = event.target as Node;
    const trigger = document.querySelector<HTMLElement>(ACCOUNT_MENU_SELECTOR);
    const bubble = document.querySelector<HTMLElement>(ACCOUNT_BUBBLE_SELECTOR);

    if (trigger?.contains(target)) {
        event.preventDefault();
        toggleAccountMenu();
        return;
    }

    if (!bubble?.contains(target)) {
        closeAccountMenu();
    }
});
